import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CreativeCardProps } from '../../models/chat-library.models';
import { CreativeCardComponent } from '../creative-card/creative-card.component';

@Component({
  selector: 'app-creative-card-grid',
  standalone: true,
  imports: [CreativeCardComponent],
  templateUrl: './creative-card-grid.component.html',
  styleUrl: './creative-card-grid.component.scss',
})
export class CreativeCardGridComponent {
  @Input() cards: CreativeCardProps[] = [];
  @Output() cardClicked = new EventEmitter<CreativeCardProps>();
}
